<template>
  <wrapper title="Nihom">
    <div class="row center" v-if="loading">
      <pre-loader></pre-loader>
    </div>
    <div class="container" v-else>
     
      <div class="row">
        <item v-for="item in data" :key="item.id" :data="item"></item>
      </div>
    </div>
  </wrapper>
</template>
<script>
import Item from "./Item.vue";
export default {
  components: {
    item: Item
  },
  mounted() {
    this.$store.dispatch("getNihomType", {});
  },
  computed: {
    data() {
      return this.$store.getters.nihom_types;
    },
    loading() {
      return this.$store.getters.nihom_type_loading;
    }
  }
};
</script>
<style lang="scss" scoped>

.container {
  padding-top: 20px;
}

.header_container h6 {
  font-size: 20px;
  text-transform: uppercase;
  color: #005555;
  border-bottom: 3px solid #005555 !important;
  padding-left: 20px;
  padding-bottom: 15px;
}
</style>